import styled from 'styled-components';
import { MAT_ASPECT } from '../Board/layout';

export const WatchPage = styled.main`
  max-width: 720px;
  margin: 0 auto;
  padding: 12px 16px 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/** The table, as wide as the page and as tall as the mat is for that width. */
export const WatchBoard = styled.div`
  width: 100%;
  aspect-ratio: ${MAT_ASPECT};
  container-type: size;
  display: flex;
`;

export const Players = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const PlayerLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 14px;
`;

/** The latest moves, newest first. */
export const Moves = styled.ul`
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.4;

  & li {
    padding: 6px 0;
    border-top: 1px solid var(--line);
  }
`;
